export const getModulePadding = (
  shouldShowImageMissionButtons: boolean,
): Record<string, unknown> => {
  if (shouldShowImageMissionButtons)
    return {
      py: {
        xs: 2,
        md: 0,
      },
    }

  return {
    py: {
      xs: 6,
      md: 7,
    },
  }
}
